import { Component, EventEmitter, HostBinding, Inject, Input, Output, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { DrawerSize, DrawerType } from './drawer.type';
import { SlideInOutAnimation, SlideDirectionAnimation } from '@sml/utility';
import { IconsComponent } from '@sml/icons';
const buildTwClasses = 'tw-block tw-fixed tw-top-0 tw-left-0 tw-w-full tw-h-full tw-z-[910] tw-bg-black tw-bg-opacity-30';
@Component({
  selector: 'sml-drawer',
  standalone: true,
  imports: [CommonModule, IconsComponent],
  templateUrl: './drawer.component.html',
  styleUrl: './drawer.component.scss',
  animations: [SlideInOutAnimation, SlideDirectionAnimation],
})
export class DrawerComponent {

  @HostBinding('class') twClasses = buildTwClasses;
  @Input() size: DrawerSize | '' = 'lg';
  @Input() headerContent = true;
  @Input() bodyContent = true;
  @Input() footerContent = true;
  @Input() drawerContainerClasses = '';
  @Input() drawerConatinerMain = '';
  @Input() bodyClass='';
  private _drawerType: DrawerType | '' = 'side';
  public isMobile = false;
  @Input() set drawerType(value: DrawerType | '') {
    this._drawerType = value;
  }
  get drawerType(): DrawerType | '' {
    return this._drawerType;
  }
  @Output() close = new EventEmitter<boolean>();
  constructor(@Inject(PLATFORM_ID) private readonly platformId: object) { }

  ngOnInit() {
    this.checkWindowSize();
  }

  closeDrawer() {
    this.close.emit(true);
  }

  checkWindowSize(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.isMobile = window.innerWidth < 768;
    }
  }
}
